import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSites } from 'hooks/sites/useSites';

import { successToast } from 'utils/successToast';

import { selectors } from 'store/slices/washhub';

import { createOrder } from 'api/order';
import { useMutation, useQueryClient } from 'react-query';

import { RefType, AddOrderModalProps } from './AddOrderModal.props';

import AddOrderModalView from './AddOrderModal.view';

import { toApiPayloadDateFormat } from 'utils/dateUtils';

const Container = forwardRef<RefType, AddOrderModalProps>((props, ref) => {
  const { selectedDay } = props;
  const queryClient = useQueryClient();
  const currentWashhub = selectors.useSelectedWashHub();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: sites = [], isLoading: isLoadingSites } = useSites();

  const { mutate, isLoading } = useMutation(createOrder, {
    onSuccess: () => {
      successToast('Order Created Successfully');

      queryClient.invalidateQueries(`${currentWashhub?._id}-fetch-orders`);

      queryClient.invalidateQueries(
        `fetch-orders-status-count-${currentWashhub?._id}`,
      );

      queryClient.invalidateQueries(`fetch-orders`);

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  const onSubmit = (values: any) => {
    const site = values?.site;
    const _site: any = sites?.find((s) => s._id === site);

    const siteCode = _site?.code || '';
    const dayOfWeek = Number(_site?.dayOfWeek || '0');

    const washHub = currentWashhub?._id || '';
    const washHubCode = currentWashhub?.code || '';

    const deliveryAt = toApiPayloadDateFormat(values?.deliveryAt);

    const details = values?.details?.map((d: any) => {
      return {
        ...d,
        casesCount: Number(d?.casesCount || '0'),
        totalItems: Number(d?.totalItems || '0'),
      };
    });

    const payload = {
      site,
      details,
      washHub,
      siteCode,
      dayOfWeek,
      deliveryAt,
      washHubCode,
      notes: values?.notes || '',
    };

    mutate(payload);
  };

  const _props = {
    sites,
    isOpen,
    onClose,
    onSubmit,
    isLoading,
    isLoadingSites,
    selectedDay,
  };

  return <AddOrderModalView {..._props} />;
});

const AddOrderModal = memo(Container);

export default AddOrderModal;
